import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {
    ISchedaCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/ISchedaCosto";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiCreateSchedaCosto = (): UseMutationResult<ISchedaCosto, CustomAxiosError, any> => {
    const {post} = useApiCalls()
    const {selectedCompany} = useAuth()

    const doCreate = async ({data}: { data: any }): Promise<ISchedaCosto> => {
        try {
            const response = await post(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<ISchedaCosto, CustomAxiosError, any>(
        {
            mutationFn: (data: {
                data: any
            }) => {

                return doCreate({
                    data
                })
            },
        }
    );
};

export default useApiCreateSchedaCosto;

